/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Page_Thanksdescription1Inputs */

const ja_contact_page_thanksdescription1 = /** @type {(inputs: Contact_Page_Thanksdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信が完了しました。担当者より追ってご連絡を差し上げます。`)
};

const en_contact_page_thanksdescription1 = /** @type {(inputs: Contact_Page_Thanksdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your message has been sent. We have also forwarded a copy of your message to the email address provided.`)
};

/**
* | output |
* | --- |
* | "Your message has been sent. We have also forwarded a copy of your message to the email address provided." |
*
* @param {Contact_Page_Thanksdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_page_thanksdescription1 = /** @type {((inputs?: Contact_Page_Thanksdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Page_Thanksdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_page_thanksdescription1(inputs)
	return en_contact_page_thanksdescription1(inputs)
});
export { contact_page_thanksdescription1 as "contact_page_thanksDescription" }